
import api from './api';

export const parentsAPI = {
     getparents:()=> api.get ('/parents/get-parents'),
      getparentsByParams: (params = {}) => api.get(`/parents/get-parents-by-params`, { params }),
     createParent: (parent) => api.post(`/parents/add-parent`, parent),
      updateParent: (parentId, parentData) => api.put(`/parents/update-parent/${parentId}`, parentData),
       deleteParent: (parentId) => api.delete(`/parents/delete-parent/${parentId}`),
};